/**
 * @module ol/extent/Relationship
 */
/**
 * Relationship to an extent.
 * @enum {number}
 */
export default {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16,
};
//# sourceMappingURL=Relationship.js.map


// WEBPACK FOOTER //
// /~/ol/extent/Relationship.js